import * as React from 'react';

const NoMessage: React.StatelessComponent<any> = () => <div className="no-msg"></div>;

export default NoMessage;
